import { useState } from 'react'
import { FaFileCirclePlus } from 'react-icons/fa6'
import Input from '../../../../shared/components/form/input'

import './formRegisterHorimetro.css'
import './formRegisterInfo.css'
/* Function */
import { monthYear, secondToHour, secondToMinute, secondToSecond } from "../../../../shared/functions/Date"
import FormRecordHorimetro from './FormRecordHorimetro'


function FormRegisterHorimetro({ permission_create, inputName, lastDid, lastHorimetroDate, lastHorimetroRecord, lastHorimetroChangeOilAndFilterDate, lastHorimetroChangeOilAndFilterRecord, lastDidOilAndFilterRecord, nextHorimetroChangeOilAndFilterDate, totalLastHorimetroChangeOilAndFilterRecord, nextHorimetroDate, handleOnSubmit }) {



    const [modalNewRecord, setModalNewRecord] = useState(false)
    const [newDate, setNewDate] = useState("")
    const [newRecord, setNewRecord] = useState({})
    const [changeOilAndFilter, setChangeOilAndFilter] = useState()


    
    function handleChange(e) {
        setNewRecord({ ...newRecord, [e.target.name]: e.target.value })
    }
    function handleChangeDate(e) {
        setNewDate(e.target.value)
    }

    async function submit(data) {
        let obj = {
            ...data,
            changeOilAndFilter: changeOilAndFilter,

        }
        let response = await handleOnSubmit(obj)
        if (response === "success") {
            setModalNewRecord(false)

        }
    }

    return (
        <div>
            <div className='form-register-info-box'>
                <span className='form-register-info-title'>Troca de Óleo e Filtro</span>
                <div className='form-register-info-box-box'>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Última realizada</span>
                        <span className='form-register-info-value'>{lastHorimetroChangeOilAndFilterDate ? monthYear(lastHorimetroChangeOilAndFilterDate) : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Horímetro da Última troca</span>
                        <span className='form-register-info-value'>{lastHorimetroChangeOilAndFilterRecord ? `${secondToHour(lastHorimetroChangeOilAndFilterRecord)}h ${secondToMinute(lastHorimetroChangeOilAndFilterRecord)}min ${secondToSecond(lastHorimetroChangeOilAndFilterRecord)}s` : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Próxima a realizar</span>
                        <span className='form-register-info-value'>{nextHorimetroChangeOilAndFilterDate ? monthYear(nextHorimetroChangeOilAndFilterDate) : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Total Rodado desde a Última troca</span>
                        <span className='form-register-info-value'>{totalLastHorimetroChangeOilAndFilterRecord ? `${secondToHour(totalLastHorimetroChangeOilAndFilterRecord)}h ${secondToMinute(totalLastHorimetroChangeOilAndFilterRecord)}min ${secondToSecond(totalLastHorimetroChangeOilAndFilterRecord)}s` : "-------"}</span>
                    </div>
                    {permission_create &&
                        <button className='form-register-info-new-btn' onClick={() => { setChangeOilAndFilter("yes"); setModalNewRecord(true) }}>
                            <FaFileCirclePlus size={14} /> Novo Registro
                        </button>
                    }
                </div>

                <div className='form-register-info-divider' />

                <span className='form-register-info-title'>Horímetro</span>
                <div className='form-register-info-box-box'>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Data do último registro</span>
                        <span className='form-register-info-value'>{lastHorimetroDate ? monthYear(lastHorimetroDate) : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Último registro</span>
                        <span className='form-register-info-value'>{lastHorimetroRecord ? `${secondToHour(lastHorimetroRecord)}h ${secondToMinute(lastHorimetroRecord)}min ${secondToSecond(lastHorimetroRecord)}s` : "-------"}</span>
                    </div>

                    {permission_create &&
                        <button className='form-register-info-new-btn' onClick={() => { setChangeOilAndFilter("no"); setModalNewRecord(true); }}>
                            <FaFileCirclePlus size={14} /> Novo Registro
                        </button>
                    }
                </div>

            </div>


            <div>

                {modalNewRecord &&
                    <>

                        <FormRecordHorimetro handleOnSubmit={submit} closeModal={() => { setModalNewRecord(false) }} changeOilAndFilter={changeOilAndFilter} />
                    </>

                }

                {/* 
                {modalNewRecord &&
                    <div>
                        <div className={"modal-background-1 "} >
                            <div className="modal-small default-model-1">
                                <div className="box-x"> <div onClick={() => { setModalNewRecord(false) }} className="x">X</div></div>

                                <div >
                                    <div className='default-title-m2'> {changeOilAndFilter === "yes" ? "Troca de Óleo e Filtro" : "Registrar Horímetro"} </div>
                                    <Input
                                        type="month"
                                        name="horimetroDate"
                                        text="Mês e Ano"
                                        handleOnChange={handleChange}
                                        value={newRecord.horimetroDate || ""}
                                    />
                                    <Input
                                        type="number"
                                        name="horimetroRecord"
                                        text={changeOilAndFilter === "yes" ? "Horimetro da Troca" : "Horímetro"}
                                        handleOnChange={handleChange}
                                        value={newRecord.horimetroRecord || ""}
                                    />



                                    <div className='bt-model-add bt-model-1 bt-width-m2' onClick={() => { submit() }} > Salvar registro</div>
                                </div>

                            </div>

                        </div >
                    </div>
                } */}
            </div>



        </div>
    )
}

export default FormRegisterHorimetro